import { Divider, IconInfo, Text } from 'braid-design-system';
import type { GraphQLScalarType } from 'graphql';
import { useLocation } from 'react-router';
import { InlineCode } from 'scoobie';

import { SchemaMarkdown } from '../components/SchemaMarkdown.tsx';
import { TypeSeenIn } from '../components/TypeSeenIn.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';

const COMMON_SCALARS = ['Boolean', 'Float', 'ID', 'Int', 'String'];

export const ScalarSchemaPage = ({
  scalarType,
}: {
  scalarType: GraphQLScalarType;
}) => (
  <BasePage
    title={{
      children: <InlineCode weight="weak">{scalarType.name}</InlineCode>,
      htmlTitle: scalarType.name,
      stringTitle: scalarType.name,
      subHeading: (
        <Text icon={<IconInfo />} size="small" weight="medium" tone="secondary">
          Scalar
        </Text>
      ),
    }}
    breadcrumbs={[
      { href: '/schema', title: 'Schema' },
      { href: useLocation().pathname, title: scalarType.name },
    ]}
  >
    <SchemaMarkdown type={scalarType.name} />

    <Divider />

    {COMMON_SCALARS.includes(scalarType.name) ? undefined : (
      <TypeSeenIn name={scalarType.name} />
    )}
  </BasePage>
);
